module.exports = __webpack_public_path__ + "static/media/8f32fdf6-cb97-4ff8-ba29-dd552c5e0181.89bae358.JPG";